const backgroundColor = 'backgroundColor';
const borderColor = 'borderColor';
const iconColor = 'iconColor';
const textColor = 'textColor';
export const aliasColorBuiltIns = {
    background: backgroundColor,
    backgroundColor,
    borderColor,
    borderBottomColor: borderColor,
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    borderTopColor: borderColor,
    color: textColor,
    fill: iconColor
};
export const aliasColor = {
    ...aliasColorBuiltIns,
    keyline: borderColor
};

//# sourceMappingURL=aliasColor.js.map